"use strict";

import Vue from 'vue';
import axios from "axios";
import {stringify} from "query-string";
import lan from "../i18n/lang/ajax/en";
import i18n from "../i18n/i18n";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
   baseURL: process.env.VUE_APP_API_URL,
  // timeout: 60 * 1000, // Timeout
   withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent


    if(config.method == 'post' && config.data) config.data = stringify(config.data, {arrayFormat: 'bracket'});

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

function translateError(message) {
  if (i18n.locale!=='en' && typeof message  === 'string' && lan[message.trim()] !== undefined){
    return lan[message.trim()]
  }
  return message;
}

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data


    if(!response.data.result){
      response.data.message = translateError(response.data.message);

      if(typeof response.data.message  === 'object'){
        const error = Object.entries(response.data.message)
        response.data.message = ""

        error.forEach((item) => {
          let m = translateError(item[1]);
          //window.console.log(m)
          response.data.message +=  "<p>" + m + "</p>";
        })

      }
    }

    return response;
  },
  function(error) {
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  window.baseURL = config.baseURL
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin;
